// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_1wj5n"};